import Alpine from "alpinejs";

import { createCalendar } from "./components/fullcalendar";

const DEFAULT_SEND_HOUR = 8;
let callback = null;

Alpine.data("emailScheduler", () => ({
  timeCalendar: null,
  dateCalendar: null,
  selectedDateTime: null,

  async getDate() {
    this.$popup.open(this.$root);
    await this.initializeCalendars();
    return new Promise((resolve) => (callback = resolve));
  },

  onSubmit() {
    this.$popup.close(this.$root);
    callback?.(this.selectedDateTime);
  },

  async initializeCalendars() {
    if (this.dateCalendar) {
      return;
    }

    [this.dateCalendar, this.timeCalendar] = await Promise.all([
      createCalendar(this.$refs.dateContainer, {
        height: 380,
        nowIndicator: true,
        headerToolbar: {
          left: "prev,next,today",
          center: "",
          right: "title",
        },
        dateClick: (info) => {
          info.date.setHours(DEFAULT_SEND_HOUR, 0, 0);
          const adjustedDate = this.adjustDate(info.date);
          this.selectedDateTime = adjustedDate;
          this.updateDateAndTimeCalendars(adjustedDate);
        },
      }),

      createCalendar(this.$refs.timeContainer, {
        initialView: "timeGridDay",
        height: 380,
        headerToolbar: false,
        dayHeaders: false,
        allDaySlot: false,
        nowIndicator: true,
        scrollTimeReset: false,
        dateClick: (info) => {
          const adjustedDate = this.adjustDate(info.date);
          this.selectedDateTime = adjustedDate;
          this.updateDateAndTimeCalendars(adjustedDate, info.date < new Date());
        },
      }),
    ]);
  },

  adjustDate(date) {
    date.setHours(date.getHours(), 0, 0, 0);
    const now = new Date();
    now.setHours(now.getHours() + 1, 0, 0, 0);
    return date < now ? now : date;
  },

  updateDateAndTimeCalendars(date, mustScroll = true) {
    this.updateCalendar(this.dateCalendar, date, { allDay: true });
    this.updateTimeCalendar(date, mustScroll);
  },

  updateTimeCalendar(date, mustScroll) {
    this.updateCalendar(this.timeCalendar, date);
    if (mustScroll) {
      this.timeCalendar.scrollToTime({ hour: date.getHours(), minutes: date.getMinutes() });
    }
  },

  updateCalendar(calendar, date, opts = {}) {
    const eventDate = calendar.getEventById("sending-date");
    if (eventDate) {
      eventDate.setDates(date, null, opts);
    } else {
      calendar.addEvent({ id: "sending-date", title: this.$root.dataset.eventLabel, start: date, ...opts });
    }
    calendar.gotoDate(date);
  },

  onClickPredefinedSendingDelay(delay) {
    if (delay === "next_monday") {
      const now = new Date();
      now.setHours(DEFAULT_SEND_HOUR, 0, 0, 0);
      now.setDate(now.getDate() + ((1 + 7 - now.getDay()) % 7));
      this.selectedDateTime = now;
      this.updateDateAndTimeCalendars(now);
      return;
    }

    const [n, t] = delay.split(" ");
    const number = parseInt(n);
    const now = new Date();
    now.setHours(DEFAULT_SEND_HOUR, 0, 0, 0);

    switch (t) {
      case "day":
        now.setDate(now.getDate() + number);
        break;
      case "week":
        now.setDate(now.getDate() + number * 7);
        break;
      case "month":
        now.setMonth(now.getMonth() + number);
        break;
    }

    // If date is SAT or SUN, adjust to next MON
    if (now.getDay() === 0) {
      now.setDate(now.getDate() + 1);
    } else if (now.getDay() === 6) {
      now.setDate(now.getDate() + 2);
    }

    this.selectedDateTime = now;
    this.updateDateAndTimeCalendars(now);
  },

  get formattedDate() {
    if (!this.selectedDateTime) return "";
    return this.selectedDateTime.toLocaleString(window._locale, {
      dateStyle: "long",
      timeStyle: "short",
    });
  },
}));

export function getDate() {
  return Alpine.$data(document.querySelector("#email-scheduler")).getDate();
}
